import { render, staticRenderFns } from "./unauthorized-page.html?vue&type=template&id=1ba35bea&"
import script from "./unauthorized-page.vue?vue&type=script&lang=js&"
export * from "./unauthorized-page.vue?vue&type=script&lang=js&"
import style0 from "./unauthorized-page.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports